import ReactPaginate from 'react-paginate'

const Pagination = ({
  // pageIndex,
  // pageSize,
  // canPreviousPage,
  // canNextPage,
  // pageOptions,
  pageCount,
  gotoPage,
  // nextPage,
  // previousPage,
  // setPageSize,
}) => {
  if (pageCount === 1) {
    return null
  }

  const handlePageClick = (data) => {
    const { selected } = data
    // let offset = Math.ceil(selected * this.props.perPage);

    gotoPage(selected)
  }

  return (
    <ReactPaginate
      previousLabel={
        <svg
          width="11"
          height="15"
          viewBox="0 0 11 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.49637 14.956L0.334351 7.64979L4.91537 3.99665L9.49637 0.343544L10.803 1.89795L3.59011 7.64979L10.803 13.4016L9.49637 14.956Z"
            fill="#2F2F2F"
          />
        </svg>
      }
      nextLabel={
        <svg
          width="11"
          height="15"
          viewBox="0 0 11 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.50363 0.0440012L10.6656 7.35022L6.08463 11.0034L1.50363 14.6565L0.197046 13.1021L7.40989 7.35022L0.197046 1.59843L1.50363 0.0440012Z"
            fill="#2F2F2F"
          />
        </svg>
      }
      breakLabel="..."
      breakClassName="break-me"
      pageCount={pageCount}
      marginPagesDisplayed={2}
      pageRangeDisplayed={5}
      onPageChange={handlePageClick}
      containerClassName="pagination"
      pageLinkClassName="primary-btn transparent"
      breakLinkClassName="primary-btn transparent"
      previousClassName="primary-btn transparent"
      nextClassName="primary-btn transparent"
      activeClassName="active"
    />
  )
}

export default Pagination
